import { render, staticRenderFns } from "./OperaTreeNode.vue?vue&type=template&id=445c226c&scoped=true"
import script from "./OperaTreeNode.vue?vue&type=script&lang=js"
export * from "./OperaTreeNode.vue?vue&type=script&lang=js"
import style0 from "./OperaTreeNode.vue?vue&type=style&index=0&id=445c226c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445c226c",
  null
  
)

export default component.exports